import { API_ENDPOINTS } from '../config/api';

export const headlineService = {
  async getCurrentHeadlines() {
    try {
      const response = await fetch(`${API_ENDPOINTS.HEADLINES}/search?type=CU`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching current headlines:', error);
      return [];
    }
  }
};